import React from 'react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  const scrollToOffer = () => {
    const el = document.getElementById('precio-final');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="pt-14 pb-4 md:pt-28 md:pb-14 px-6 max-w-5xl mx-auto text-center" data-id="element-119">
      <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-navy leading-tight mb-6" data-id="element-120">
        ¿Sentís que tu cerebro funciona{' '}
        <span className="italic text-accent" data-id="element-121">"a media máquina"</span>?
      </h1>

      <h2 className="text-xl md:text-2xl font-medium text-navy/80 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-122">
        Despejá la <strong className="text-navy" data-id="element-123">niebla mental</strong> en{' '}
        <strong className="text-navy" data-id="element-124">3 días</strong> y recuperá la{' '}
        <strong className="text-navy" data-id="element-125">energía</strong> que dabas por perdida.
      </h2>

      <p className="text-lg text-navy/70 mb-6 md:mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-126">
        Descubrí por qué el{' '}
        <strong className="text-navy" data-id="element-127">cansancio crónico</strong>{' '}
        <strong className="text-navy" data-id="element-128">nada tiene que ver con tu edad, ni con el nivel de exigencia de tu rutina</strong>.
        Un método de{' '}
        <span className="text-accent font-semibold" data-id="element-129">reinicio biológico</span>{' '}
        para recuperar el enfoque y la ligereza{' '}
        <strong className="text-accent font-semibold" data-id="element-130">
          sin procesos complejos ni dependencia química externa
        </strong>
        .
      </p>

      <CtaButton onClick={scrollToOffer} className="text-2xl" data-id="element-131">
        QUIERO RECUPERAR MI ENERGÍA
      </CtaButton>
    </section>;
}